//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('equipmentGrps', {
//        templateUrl: 'views/components/views/equipmentGrps/equipmentGrps.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['stateService', 'equipmentGrpsService', function (stateService, equipmentGrpsService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
            
//            vm.model = {
//                itemsListEquipmentGroups: []
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region LOAD PROCEDURE FUNCTION CALLS

//            async function loadEquipmentGroupViews() {
//                vm.model.itemsListEquipmentGroups = (await equipmentGrpsService.listEquipmentGrpViews());
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALLS

//            // #region MULTI DIRECTION BUTTON FUNCTIONS

//            vm.goToFunc = function (state, e) {
//                let go = function (parms) {
//                    if (e?.ctrlKey) {
//                        stateService.newTab(state, parms);
//                    } else {
//                        stateService.go(state, parms);
//                    }
//                };

//                switch (state) {
//                    case 'equipmentgrp':
//                        go({ equipmentgrp_id: '0' });
//                        break;
//                    default:
//                        break;
//                }
//            };

//            // #endregion MULTI DIRECTION BUTTON FUNCTIONS

//            // #region ON INIT FUNCTION

//            vm.$onInit = function () {
//                loadEquipmentGroupViews();
//            };

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
